import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable, forkJoin } from 'rxjs';
import { MwLoadOptionsService } from 'app/services/utils/load-options.service';
import { MwLoadOptions } from 'app/models/load-options.model';
import { ProductGroupApiModel } from '../models/product-group-api.model';
import { MwPayloadModel } from 'app/models/payload.model';

@Injectable({ providedIn: 'root' })
export class MwProductGroupsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  private apiEndpoint = '/integration/v1/Companies/{companyId}/ProductGroups';

  getProductGroups(
    requestModel?: MwLoadOptions
  ): Observable<ProductGroupApiModel[]> {
    let query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    query = query.length > 0 ? '?' + query : query;

    return this.http.authGet<ProductGroupApiModel[]>(
      `${this.apiEndpoint}${query}`
    );
  }

  createProductGroup(
    productGroup: ProductGroupApiModel
  ): Observable<ProductGroupApiModel> {
    return this.http.authPost<ProductGroupApiModel>(this.apiEndpoint, {
      body: productGroup,
    });
  }

  updateProductGroup(
    productGroup: ProductGroupApiModel
  ): Observable<ProductGroupApiModel> {
    return this.http.authPut<ProductGroupApiModel>(this.apiEndpoint, {
      body: productGroup,
    });
  }

  deleteProductGroup(productGroup: ProductGroupApiModel): Observable<any> {
    return this.http.authDelete<ProductGroupApiModel>(this.apiEndpoint, {
      body: productGroup,
    });
  }

  deleteProductGroupsList(
    productGroups: ProductGroupApiModel[]
  ): Observable<any> {
    return forkJoin(
      productGroups.map((project) =>
        this.http.authDelete<ProductGroupApiModel[]>(this.apiEndpoint, {
          body: project,
        })
      )
    );
  }
}
